import { sendMessage as e } from "../messaging/service-worker/sender.js";
const o = {
  /**
   * @example sendMessage<"blockTabs"> will enforce the params of sendMessage to require the compatible types
   */
  sendMessage: e
};
export {
  o as default
};
